import { render, staticRenderFns } from "./AppointTransfer.vue?vue&type=template&id=c9c2fb18&scoped=true&"
import script from "./AppointTransfer.vue?vue&type=script&lang=js&"
export * from "./AppointTransfer.vue?vue&type=script&lang=js&"
import style0 from "./AppointTransfer.vue?vue&type=style&index=0&id=c9c2fb18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c2fb18",
  null
  
)

export default component.exports